import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from './ModalSectionCard.module.scss';

type ModalSectionCardProps = {
	className?: string;
	paddingSize?: '0' | 'sm' | 'md' | 'lg';
	borderRadiusSize?: 'sm' | 'md';
};

export const ModalSectionCard: React.FC<ModalSectionCardProps> = ({
	className,
	children,
	paddingSize = 'md',
	borderRadiusSize = 'md',
}) => {
	const classes = classNames([
		styles.modalsectioncard,
		styles[`padding-size-${paddingSize}`],
		styles[`border-radius-size-${borderRadiusSize}`],
		className,
	]);

	return <div className={classes}>{children}</div>;
};
